export var Level;
(function (Level) {
    Level["Hero"] = "hero";
    Level["SubHero"] = "subHero";
    Level["Title"] = "title";
    Level["SubTitle"] = "subTitle";
    Level["Heading"] = "heading";
    Level["SubHeading"] = "subHeading";
    Level["Section"] = "section";
    Level["SubSection"] = "subSection";
})(Level || (Level = {}));
//# sourceMappingURL=IHeading.js.map